/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useMemo, useRef, useState } from 'react';

import { useUtils } from '../../../../core/hooks/useUtils';
import { addCommentAction } from '../../../../store/Comments/action';

interface IInput {
	item: any;
}

interface IOutput {
	state: HookState;
	messagesEndRef: any;
	user: any;
	sections: any;
	handleChange(e: React.ChangeEvent<HTMLInputElement>): void;
	onSendComment(): void;
}

interface HookState {
	comment: string;
}

export default function useHook({ item }: IInput): IOutput {
	const {
		dispatch,
		store: { user, comments },
	} = useUtils();

	const { data } = comments;

	const messagesEndRef = useRef<any>(null);

	const [state, setState] = useState<HookState>({
		comment: '',
	});

	const sections = useMemo(() => {
		const uniqueDays = Array.from(
			new Set(data.map((comment: any) => moment(comment.createdAt).dayOfYear()))
		).sort((a: any, b: any) => a - b);
		return uniqueDays.map((day: any) => {
			const chartsByDay = data
				.filter((comment: any) => moment(comment.createdAt).dayOfYear() === day)
				.sort((a: any, b: any) =>
					moment.utc(a.createdAt).diff(moment.utc(b.createdAt))
				);
			return {
				title: moment().dayOfYear(day).format('D MMMM'),
				data: chartsByDay,
			};
		});
	}, [comments]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		setState(prev => ({
			...prev,
			comment: e.target.value,
		}));
	};

	const onSendComment = (): void => {
		const { firstName, lastName, _id } = user.data;
		const fullName = `${firstName || ''} ${lastName || ''}`;
		dispatch(
			addCommentAction({
				data: {
					name: fullName,
					content: comment,
					sharedSnapId: item._id,
					userId: _id,
				},
				callback: () => {
					messagesEndRef?.current.scrollIntoView({
						behavior: 'smooth',
						block: 'nearest',
						inline: 'nearest',
					});
				},
			})
		);
		setState(prev => ({
			...prev,
			comment: '',
		}));
	};

	const { comment } = state;

	return {
		state,
		messagesEndRef,
		user: user.data,
		sections,
		handleChange,
		onSendComment,
	};
}
